"use client"

import { useEffect, useRef } from "react"
import { trackMetaTelemetry } from "./meta-event-client"

type MetaViewContentProps = {
  productId: string
  variantId: string
  value?: number
  currency?: string
  path: string
}

export default function MetaViewContent({
  productId,
  variantId,
  value,
  currency,
  path,
}: MetaViewContentProps) {
  const lastTrackedIdentityRef = useRef<string | null>(null)

  useEffect(() => {
    const identity = `${path}\u0000${productId}\u0000${variantId}`
    if (lastTrackedIdentityRef.current === identity) return
    lastTrackedIdentityRef.current = identity

    trackMetaTelemetry({
      event_name: "ViewContent",
      path,
      content: {
        product_id: productId,
        variant_id: variantId,
        ...(value !== undefined ? { value } : {}),
        ...(currency ? { currency } : {}),
      },
    })
  }, [currency, path, productId, value, variantId])
  return null
}
